async function getPositioning(SKU, vehicleID){
  
  var strSKU = SKU + '';
  while (strSKU.length < 7) 
    strSKU = '0' + strSKU;

  var positions;
  var str;
  var obj;

  var url;
  
  var myDiv;
  var divID ;

  //alert(strSKU);
  
  divID = 'part_position_' + strSKU;
  
  myDiv = document.getElementById(divID);

  
  $(myDiv).html("Position: ");
  url = 'https://ps-whi-stage.azurewebsites.net/v2/parts/positions?sku=' + strSKU + '&vehicleId=' + vehicleID;
  //url = 'https://ps-whi-test.azurewebsites.net/v2/parts/positions?sku=0204169&vehicleId=453360';

  let response = await fetch(url);
  let data = await response.json();
  var strPosition = data.positions;
  //let positions = await data();
  if ($.trim(strPosition) == "" || strPosition.includes("undefined") ){
    //$(myDiv).html("REMOVE THIS");
    $(myDiv).hide();
  }else{
    $(myDiv).html("Position: " + strPosition);
  }
/*  
    // FETCH
    fetch(url)
    .then(res => res.json())
    .then(data => obj = data)
    .then(obj => objPositions = obj.data.positions)
    .then(function() {
      positions = objPositions;
      //alert("api call");
      $(myDiv).html("Position: " + positions); 
    }).catch(function(){
  });
*/

}